export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_NAV_BEHIND = 'TOGGLE_NAV_BEHIND';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const NAVIGATE_ROUTER = 'NAVIGATE_ROUTER';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';



// WEBPACK FOOTER //
// ./constants/ActionTypes.js